
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import * as api from '../../api';

export function* getMasterCoursesCountries() {
    const payload = yield call(api.getMasterCoursesCountries);
    if (payload.status === 200) {
        yield put(actions.getMasterCoursesCountriesSuccess(payload.data));
    } else {
        yield put(actions.getMasterCoursesCountriesFailure());
    }
}

export function* getMasterCoursesCountriesSaga() {
    yield takeLatest(actions.GET_MASTER_COURSES_COUNTRIES_REQUEST, getMasterCoursesCountries);
}

export function* getSubjects() {
    const payload = yield call(api.getSubjects);
    if (payload.status === 200) {
        yield put(actions.getSubjectsSuccess(payload.data));
    } else {
        yield put(actions.getSubjectsFailure());
    }
}

export function* getSubjectsSaga() {
    yield takeLatest(actions.GET_SUBJECTS_REQUEST, getSubjects);
}

export function* getMasterCoursesByCountry(countryCode) {
    const payload = yield call(api.getMasterCoursesByCountry, countryCode);
    if (payload.status === 200) {
        const courses = payload.data.map((item) => {
            const yearGroups = [];
            item.yearGroups.forEach((yearGroup) => {
                yearGroups.push(yearGroup.yearGroupEnum);
            });
            item.yearGroupCombined = yearGroups.join(', ');
            item.yearGroupList = yearGroups;
            return item;
        });
        yield put(actions.getMasterCoursesByCountrySuccess(courses));
    } else {
        yield put(actions.getMasterCoursesByCountryFailure());
    }
}

export function* getMasterCoursesByCountrySaga() {
    yield takeLatest(actions.GET_MASTER_COURSES_BY_COUNTRY_REQUEST, getMasterCoursesByCountry);
}

export function* getMasterCourses(accessStatus) {
    const payload = yield call(api.getMasterCourses, accessStatus);
    if (payload.status === 200) {
        const courses = payload.data.map((item) => {
            const yearGroups = item.yearGroups.map(yearGroup => yearGroup.yearGroupEnum);
            return {
                ...item,
                yearGroupCombined: yearGroups.join(', '),
                yearGroupList: yearGroups
            };
        });
        yield put(actions.getMasterCoursesSuccess(courses));
    } else {
        yield put(actions.getMasterCoursesFailure());
    }
}

export function* getMasterCoursesSaga() {
    yield takeLatest(actions.GET_MASTER_COURSES_REQUEST, getMasterCourses);
}



// WEBPACK FOOTER //
// ./app/containers/master-courses/saga.js